import { lazy } from "react";
import { ERouteMappingKeys } from "./routeKeys";

export const cloudKeysGatewaysRoutes = {
  [ERouteMappingKeys.CLOUD_KEYS_GATEWAYS]: {
    id: "cloud-keys-gateways",
    path: "/integrations/cloud-keys-gateways",
    components: {
      "control-plane-options": lazy(() =>
        import("pages/Sections/Integrations/ControlPlaneOptions").then((p) => ({
          default: p.ControlPlaneOptions,
        })),
      ),
      "independent-gateways": lazy(() =>
        import("pages/Sections/Integrations/IndependentGateways").then((p) => ({
          default: p.IndependentGateways,
        })),
      ),
    },
  },
};
